import React, { useEffect, useRef } from 'react';
import { select } from 'd3-selection';

import ErrorBoundary from '../ErrorBoundary';

function D3Component(props) {
  // We won't be rendering children, we just want to filter them out!
  const { children, element = 'g', className = '', graph, ...rest } = props;
  if (children) {
    console.warn('Incorrect use of D3Component. Do not try to pass children to the component!');
  }
  const { init = f => f, render = () => null, destroy = f => f } = graph;
  const el = useRef(null);
  useEffect(() => {
    const selection = select(el.current).datum({ ...rest });
    init(selection);
    render(selection);
    return () => {
      destroy(selection);
    }
  }, [init, render, destroy, rest]);
  return React.createElement(element, {
    className: `d3-component${className ? ' ' : ''}${className}`,
    ref: el,
  });
}

function ErrorHandledD3Component(props) {
  return (
    <ErrorBoundary>
      <D3Component {...props} />
    </ErrorBoundary>
  );
} 

export default ErrorHandledD3Component;


/*
import React, { useEffect, useRef } from 'react';
import { select } from 'd3-selection';

function D3Component(props) {
  const { render = () => null, children, ...rest } = props;
  const el = useRef(null);
  useEffect(() => {
    const selection = select(el.current).datum({ ...rest });
    render(selection);
  }, [props, render, rest]);
  return (
    <g className="d3-component" ref={el} />
  );
}

export default D3Component;
*/
/*
import React, { Component } from 'react';
import { select } from 'd3-selection';

class D3Component extends Component {
  componentDidMount() {
    this.updateG();
  }

  componentDidUpdate() {
    this.updateG();
  }

  componentWillUnmount() {
    console.log('Unmounting D3 component', this.el, this.props);
    select(this.el).selectAll('*').remove();    
  }

  updateG() {
    console.log('Rendering D3 component', this.el, this.props);
    if (this.el) {
      const { render = () => null, children, ...rest } = this.props;
      const selection = select(this.el).datum({ ...rest });
      render(selection);
    }
  }

  render() {
    return (
      <g className="d3-component" ref={el => this.el = el} />
    );
  }
}

export default D3Component;
*/

/*
import React, { useEffect, useRef } from 'react';
import { select } from 'd3-selection';

function D3Component(props) {
  const { render = () => null, children, ...rest } = props;
  const el = useRef(null);
  useEffect(() => {
    console.log('Rendering D3 component', { el, props }, el.current);
    const selection = select(el.current).datum({ ...rest });
    render(selection);
    return () => {
      console.log('Unmounting D3 component', { el, props });
    }
  }, [props, render, rest]);
  return (
    <g className="d3-component" ref={el} />
  );
}

export default D3Component;
*/